<template>
  <div
    class="footer-contact-us"
    :class="classes"
    :data-preload="[$options.name]"
  >
    <div class="footer-contact-us__content content">
      <span class="content__headline" role="heading" aria-level="2">
        {{ title }}
      </span>

      <template v-if="!hidePhoneNumber">
        <MaskedLink
          class="content__phone"
          :redirect-to="`tel:${phone}`"
          :text="formattedPhone"
        />

        <span class="content__times">
          {{ openingTimes }}
        </span>
      </template>
    </div>

    <Button
      class="footer-contact-us__button qa-Button"
      :modifiers="['secondary', 'slim']"
      :href="`mailto:${email}`"
      title="E-Mail"
    />
  </div>
</template>

<script>
import Button from 'Components/01-atoms/button/Button.vue';
import globalMixin from 'Libs/mixins/globalMixin';
import MaskedLink from 'Components/01-atoms/masked-link/MaskedLink';

export default {
  name: 'FooterContactUs',
  components: {
    Button,
    MaskedLink,
  },
  mixins: [globalMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    formattedPhone: {
      type: String,
      required: true,
    },
    openingTimes: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      required: true,
    },
    hidePhoneNumber: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.footer-contact-us {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-contact-us__content {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: baseline;
}

.content__headline {
  font-weight: bold;
  font-size: 18px;
  color: var(--color-mine-shaft);
  line-height: 30px;
}

.content__phone {
  margin-top: 4px;
  font-weight: bold;
  font-size: var(--font-size-L);
  line-height: 30px;

  color: var(--color-secondary);
}

.content__times {
  font-size: var(--font-size-SM);
  line-height: 30px;
  color: var(--color-rolling-stone);
}

.footer-contact-us__button {
  margin: var(--space-0--half) 0;
  white-space: nowrap;
}
</style>
